import { Component, OnInit, ChangeDetectorRef, Input, EventEmitter } from '@angular/core';
import { Router } from '@angular/router';

import 'rxjs';
import 'angular2-expandable-list';
@Component({
  selector: 'app-layoutlogin',
  templateUrl: './layoutlogin.component.html',
})

export class LayoutLoginComponent implements OnInit {
  UserInfo: string;
  UserName: string;
  islogin: boolean = false;
  constructor(private _router: Router) {
    this.UserInfo = JSON.parse(sessionStorage.getItem('userinfo'));
  }


  ngOnInit() {
    if (this.UserInfo != null || this.UserInfo != undefined)
      this.islogin = true;
  }

  logOut() {
    sessionStorage.clear();
    this._router.navigate(['/landing']);
  }

}
